<template>
  <font-awesome-icon
    class="icon-reviews-star"
    color="#e1cd9d"
    icon="star"
    size="lg"
  />
</template>

<script>
  export default {
    name: 'IconReviewsStar',
  }
</script>
<style lang="less" scoped>
  .icon-reviews-star {
    font-size: 22px;
    top: -2px;
    position: relative;
  }
</style>
